<template>
    <!-- User Profile Persoanl Basic Edit Info Tab Content View From Account Profile -->
    <div>
        <div class="tabs-content-secondblock mb-7">
            <div class="row" v-if="ajaxCallinprogress">
                <div class="col-lg-12 py-5 px-3 mt-10">
                    <div class="flex-container">
                        <half-circle-spinner :animation-duration="1000" :size="60" color="#005dae" />
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="ml-2 mr-1">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="infoHeader mt-4 pb-4">
                                <div class="a-q-Jc-j-editcontactView mt-1">
                                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                                        <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">
                                            First Name
                                            <sup class="fs-14 ml-1 mandatory">*</sup>
                                        </div>
                                        <div class="a-q-Jc-Lb-editcontactView">
                                            <span class="a-q-Jc-wg-editcontactView font-color">
                                                <input class="inputField text-capitalize" type="text" data-vv-scope="profile_data" name="first_name" v-model="editPersonalData.first_name.value" :maxlength="maxlengthaccountfirstname" data-vv-as="First Name" v-validate="{required:true,regex:/^[a-zA-Z _*]+$/}" placeholder="Enter First Name" />
                                                <span class="editcharacter-count text-grey">{{maxlengthaccountfirstname - editPersonalData.first_name.value.length}}/20</span>
                                                <span class="invalid-feedback-form text-danger mt-4" style="text-transform: none !important;" v-show="errors.has('profile_data.first_name')">{{errors.first('profile_data.first_name')}}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="infoHeader mt-4 pb-4">
                                <div class="a-q-Jc-j-editcontactView mt-10">
                                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                                        <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Middle Name</div>
                                        <div class="a-q-Jc-Lb-editcontactView">
                                            <span class="a-q-Jc-wg-editcontactView text-runcate">
                                                <input class="inputField text-capitalize" type="text" v-model="editPersonalData.middle_name.value" :maxlength="maxlengthaccountlastname" data-vv-scope="profile_data" name="middle_name" placeholder="Enter Middle Name" />
                                                <span class="editcharacter-count text-grey">{{maxlengthaccountlastname - editPersonalData.middle_name.value.length}}/20</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="infoHeader mt-4 pb-4">
                                <div class="a-q-Jc-j-editcontactView mt-10">
                                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                                        <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Last Name<sup class="fs-14 ml-1 mandatory">*</sup></div>
                                        <div class="a-q-Jc-Lb-editcontactView">
                                            <span class="a-q-Jc-wg-editcontactView">
                                                <input class="inputField text-capitalize" type="text" v-model="editPersonalData.last_name.value" :maxlength="maxlengthaccountlastname" data-vv-scope="profile_data" name="last_name" data-vv-as="Last Name" v-validate="{required:true,regex:/^[a-zA-Z _*]+$/}" placeholder="Enter Last Name" />
                                                <span class="editcharacter-count text-grey">{{maxlengthaccountlastname - editPersonalData.last_name.value.length}}/20</span>
                                                <span class="invalid-feedback-form text-danger mt-4" style="text-transform: none !important;" v-show="errors.has('profile_data.last_name')">{{errors.first('profile_data.last_name')}}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="infoHeader mt-4 pb-4">
                                <div v-if="editPersonalData.gender.value == 'Male' || editPersonalData.gender.value == 'Female'" class="a-q-Jc-j-editcontactView mt-10">
                                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                                        <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-4">Gender<sup class="fs-14 ml-1 mandatory">*</sup></div>
                                        <div class="a-q-Jc-Lb-editcontactView pb-3">
                                            <span class="a-q-Jc-wg-editcontactView">
                                                <div class="preview-elements previewElementsContacts radiooptions mt-3">
                                                    <div class="form-check form-check-inline">
                                                        <label class="form-check-label check-label-dc">
                                                            <input class="form-check-input" data-vv-scope="profile_data" data-vv-as="Gender" type="radio" name="gender" v-model="editPersonalData.gender.value" value="Male" />
                                                            <span class="radio-icon"></span>
                                                            <span class="form-check-description fw-600" style="font-size: 14px !important;">Male</span>
                                                        </label>
                                                    </div>
                                                    <div class="form-check form-check-inline">
                                                        <label class="form-check-label check-label-dc" style="width: 63px;">
                                                            <input class="form-check-input" data-vv-scope="profile_data" data-vv-as="Gender" type="radio" name="gender" v-model="editPersonalData.gender.value" value="Female" />
                                                            <span class="radio-icon"></span>
                                                            <span class="form-check-description fw-600" style="font-size: 14px !important;">Female</span>
                                                        </label>
                                                    </div>
                                                    <div class="form-check form-check-inline">
                                                        <label class="form-check-label check-label-dc">
                                                            <input class="form-check-input" type="radio" data-vv-scope="profile_data" @click="editPersonalData.gender.value = ''"/>
                                                            <span class="radio-icon"></span>
                                                            <span class="form-check-description fw-600" style="font-size: 14px !important;">Custom</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="a-q-Jc-j-editcontactView mt-10">
                                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                                        <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-4">Gender<sup class="fs-14 ml-1 mandatory">*</sup></div>
                                        <div class="a-q-Jc-Lb-editcontactView pb-3">
                                            <span class="a-q-Jc-wg-editcontactView">
                                                <div class="preview-elements previewElementsContacts radiooptions mt-3">
                                                    <div class="form-check form-check-inline">
                                                        <label class="form-check-label check-label-dc w-100">
                                                            <input class="form-check-input" type="radio" data-vv-scope="profile_data" :checked="editPersonalData.gender.value == 'Male' || editPersonalData.gender.value == 'Female' ? false : true" />
                                                            <span class="radio-icon"></span>
                                                            <span class="form-check-description fw-600" style="font-size: 14px !important;">Custom</span>
                                                            <input name="custom_gender" data-vv-scope="profile_data" v-validate="'required'" type="text" v-model="editPersonalData.gender.value" maxlength="20" style=" margin-left: 10px; border-bottom: 1px solid; background: transparent; padding-right: 15px;">
                                                            <span class="text-grey fs-12" style="margin-top: 0px; margin-left: 15px;position:absolute;right:0px;top:24px">{{20 - editPersonalData.gender.value.length}}/20</span>
                                                            <span style="cursor: pointer; margin-left: -10px;" @click="editPersonalData.gender.value = 'Male'">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/cross-default-blue.svg" height="10px">
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger mt-1" style="text-transform: none !important;" v-show="errors.has('custom_gender')">This field is required</span>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="infoHeader mt-4 pb-4">
                                <div class="a-q-Jc-j-editcontactView mt-10">
                                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                                        <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-2">Date of Birth</div>
                                        <div class="a-q-Jc-Lb-editcontactView">
                                            <span class="a-q-Jc-wg-editcontactView">
                                                <date-picker v-model="editPersonalData.date_of_birth.value" :first-day-of-week="7" :not-after="new Date()" data-vv-scope="profile_data" data-vv-as="Date Of Birth" name="date_of_birth" class="calendarYear mx-left calendar-edit-per" format="DD/MM/YYYY" lang="en" :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="infoHeader mt-4 pb-4">
                                <div class="a-q-Jc-j-editcontactView mt-10">
                                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                                        <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">About</div>
                                        <div class="a-q-Jc-Lb-editcontactView">
                                            <span class="a-q-Jc-wg-editcontactView">
                                                <textarea-autosize class="digi-textarea" placeholder="Enter Text Here.." v-model="editPersonalData.about.value" :min-height="minHeight" :max-height="maxHeight" :maxlength="maxlengthaccountabout" data-vv-scope="profile_data" data-vv-as="About" name="about" style="border: none!important;border-bottom: solid 1px #a9aaad !important;border;border-radius: 0px!important;text-transform: capitalize" />
                                                <span class="editcharacter-count text-grey">{{maxlengthaccountabout - editPersonalData.about.value.length}}/1000</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="infoHeader mt-4 pb-4">
                                <div v-for="(tax,index) in editPersonalData.tax_id" :key="index" class="a-q-Jc-j-editcontactView" :class="index == 0 ? 'mt-10' : 'mt-0'">
                                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                                        <div v-if="index == 0" class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Tax ID
                                            <sup class="fs-14 ml-1 mandatory">
                                                <el-tooltip class="item" effect="light" content="The options for this field are configurable in the Settings page" placement="right">
                                                    <i class="icon-information text-secondary" style="font-size: 14px"></i>
                                                </el-tooltip>
                                            </sup>
                                        </div>
                                        <div v-else class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3"></div>
                                        <div class="a-q-Jc-Lb-editcontactView flex-column">
                                            <div class="a-q-Jc-wg-editcontactView d-flex justify-content-between">
                                                <div class="d-flex">
                                                    <multiselect class="digi-multiselect mr-2" v-model="tax.tax_id_type" :options="['SSN','EIN']" :hide-selected="true" :close-on-select="true" :show-labels="false" @select="taxTypeSelected($event, index,tax)" placeholder="Type" open-direction="bottom" :name="'tax_type'+index" style="margin-top: 1px; width: 100px !important;"></multiselect>
                                                    <input type="text" :ref="`tax${index}1`" v-model="tax.tax1" class="otpTextInput" @input="taxInput($event,index)" maxlength="1">
                                                    <input type="text" :ref="`tax${index}2`" v-model="tax.tax2" class="otpTextInput" @input="taxInput($event,index)" maxlength="1">
                                                    <input type="text" :ref="`tax${index}3`" v-model="tax.tax3" class="otpTextInput" @input="taxInput($event,index)" maxlength="1">
                                                    <input type="text" :ref="`tax${index}4`" v-model="tax.tax4" class="otpTextInput" @input="taxInput($event,index)" maxlength="1">
                                                    <input type="text" :ref="`tax${index}5`" v-model="tax.tax5" class="otpTextInput" @input="taxInput($event,index)" maxlength="1">
                                                    <input type="text" :ref="`tax${index}6`" v-model="tax.tax6" class="otpTextInput" @input="taxInput($event,index)" maxlength="1">
                                                    <input type="text" :ref="`tax${index}7`" v-model="tax.tax7" class="otpTextInput" @input="taxInput($event,index)" maxlength="1">
                                                    <input type="text" :ref="`tax${index}8`" v-model="tax.tax8" class="otpTextInput" @input="taxInput($event,index)" maxlength="1">
                                                </div>
                                                <div class="d-flex align-items-end">
                                                    <span v-if="index > 0" @click="deleteTaxID(index)" style="cursor: pointer;">
                                                        <img class="mr-2" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/trash.svg" style="height: 15px;" />
                                                    </span>
                                                    <span @click="resetTaxID(index)" style="cursor: pointer;">
                                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset-icon-default-blue.svg" style="height: 15px;" />
                                                    </span>
                                                </div>
                                            </div>
                                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-if="is_tax_type && index == current_tac_index">Tax ID is required</span>
                                            <!-- <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-if="is_tax && index == current_tac_index">Tax Type is required</span> -->
                                            <!-- <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-if="is_tax">Tax ID</span>
                                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-if="is_tax_type">Tax Type</span> -->
                                        <!-- <span class="invalid-feedback-form text-danger mb-5" style="margin-top: 4px !important;" v-if="tax.tax_id_type == '' && index == editPersonalData.tax_id.length">Tax type is required</span>
                                        <span class="invalid-feedback-form text-danger mb-5" style="margin-top: 4px !important;" v-if="tax.tax_id_type && index == editPersonalData.tax_id.length">Tax id is required</span> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right mr-2 mt-5">
                                    <button class="btn btn-new-green btn-smm" @click="addTaxID">+ Add Tax ID</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from "moment";
    import { User } from "./mixins/user.js";
    import QrcodeVue from "qrcode.vue";
    import bloodgroup from "./json/bloodgroup.json";
    import VueTextareaAutosize from "vue-textarea-autosize";
    import { HalfCircleSpinner } from "epic-spinners";
    import { EventBus } from "./eventBus/nav-bar-event.js";
    export default {
        data() {
            const value2date = (dateRange) => {
                const date = new Date(dateRange)
                return dateRange ? new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000) : null
            }
            const date2value = (date) => {
                return date ? new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000) : null
            }
            return {
                valueType: {
                    value2date,
                    date2value
                },
                isSubmitted: false,
                is_tax_type: false,
                is_tax:false,
                // tax_id_type:"",
                bloodgroup: bloodgroup,
                valueqr: "https://example.com",
                size: 90,
                maxlengthaccountfirstname: 20,
                maxlengthaccountlastname: 20,
                maxlengthaccountpassword: 20,
                maxlengthaccountprimaryemail: 230,
                maxlengthaccountotheremails: 230,
                maxlengthaccountabout: 1000,
                minHeight: 10,
                maxHeight: 350,
                editPersonalData: {
                    first_name: {
                        privacy: "contacts",
                        value: ""
                    },
                    last_name: {
                        privacy: "contacts",
                        value: ""
                    },
                    middle_name: {
                        privacy: "contacts",
                        value: ""
                    },
                    gender: {
                        privacy: "contacts",
                        value: ""
                    },
                    about: {
                        privacy: "contacts",
                        value: ""
                    },
                    date_of_birth: {
                        privacy: "contacts",
                        value: ""
                    },
                    tax_id: [{
                        tax1: "",
                        tax2: "",
                        tax3: "",
                        tax4: "",
                        tax5: "",
                        tax6: "",
                        tax7: "",
                        tax8: "",
                        tax_id: "",
                        tax_id_type: ""
                    }]
                },
                ajaxCallinprogress: false,
                requestResponse: false,
                userBasicInfo: {},
                current_tac_index: ''
            };
        },
        mixins: [User],
        methods: {
            // Adding editPersonalData empty array and updating user data
            updatePersonalInfo() {
                if (!this.is_tax_type) {
                    // this.taxValidation()
                    // this.taxTypeValidation()
                    this.ajaxCallinprogress = true
                    if (this.editPersonalData.date_of_birth.value == "-") {
                        delete this.editPersonalData["date_of_birth"];
                    }
                    if(this.editPersonalData.date_of_birth.value ){
                        let data = this.editPersonalData.date_of_birth.value.toLocaleString()
                        if(this.userBasicInfo.date_of_birth){
                            if(this.userBasicInfo.date_of_birth.value != data){
                                var date = new Date(this.editPersonalData.date_of_birth.value);
                                date.setDate(date.getDate() + 1);
                                this.editPersonalData.date_of_birth.value = date;
                                this.editPersonalData.date_of_birth.value = this.editPersonalData.date_of_birth.value.toISOString();
                            }
                        }
                    }
                    if (this.editPersonalData.tax_id.forEach((x, index) => {
                        if (!x.tax1 || !x.tax2 || !x.tax3 || !x.tax4 || !x.tax5 || !x.tax6 || !x.tax7 || !x
                            .tax8) {
                            this.editPersonalData.tax_id.splice(index, 1);
                        }
                    }));
                    this.userBasicInfo.first_name.value = this.editPersonalData.first_name.value;
                    if(this.userBasicInfo.hasOwnProperty('middle_name')){
                        this.userBasicInfo.middle_name.value = this.editPersonalData.middle_name.value;
                    }
                    if(this.userBasicInfo.hasOwnProperty('last_name')){
                        this.userBasicInfo.last_name.value = this.editPersonalData.last_name.value;
                    }
                    else{
                        this.userBasicInfo['last_name'] = {
                            value : this.editPersonalData.last_name.value
                        }
                    }
                    if(this.userBasicInfo.hasOwnProperty('gender')){
                        this.userBasicInfo.gender.value = this.editPersonalData.gender.value;
                    }
                    if(this.userBasicInfo.hasOwnProperty('about')){
                        this.userBasicInfo.about.value = this.editPersonalData.about.value;
                    }
                    this.saveEditUser(this.editPersonalData);
                    this.$emit('updateUserData');
                }
            },
            resetTaxID(index) {
                this.editPersonalData.tax_id[index].tax_id = "";
                this.editPersonalData.tax_id[index].tax1 = "";
                this.editPersonalData.tax_id[index].tax2 = "";
                this.editPersonalData.tax_id[index].tax3 = "";
                this.editPersonalData.tax_id[index].tax4 = "";
                this.editPersonalData.tax_id[index].tax5 = "";
                this.editPersonalData.tax_id[index].tax6 = "";
                this.editPersonalData.tax_id[index].tax7 = "";
                this.editPersonalData.tax_id[index].tax8 = "";
                this.editPersonalData.tax_id[index].tax_id_type = "";
                this.updateForce();
                this.is_tax_type = false
            },
            addTaxID() {
                this.editPersonalData.tax_id.push({
                    tax_id: "",
                    tax_id_type: "",
                    tax1: "",
                    tax2: "",
                    tax3: "",
                    tax4: "",
                    tax5: "",
                    tax6: "",
                    tax7: "",
                    tax8: "",
                });
                this.updateForce();
            },
            deleteTaxID(index) {
                this.editPersonalData.tax_id.splice(index, 1);
                this.updateForce();
                this.is_tax_type = false
            },
            taxInput(e, index) {
                let input = this.editPersonalData.tax_id[index];
                input.tax_id = input.tax1 + input.tax2 + input.tax3 + input.tax4 + input.tax5 + input.tax6 + input
                    .tax7 + input.tax8;
                if (e.target.value && e.target.nextElementSibling && e.keyCode != 8) {
                    e.target.nextElementSibling.focus();
                } else {
                    e.target.previousElementSibling.focus();
                }
                this.current_tac_index = index;
                this.editPersonalData.tax_id.forEach(tax => {
                    if(tax.tax_id_type && (tax.tax_id.length < 8)){
                        this.is_tax_type = true
                        this.$emit("check_tax",this.is_tax_type)
                    }
                    if((tax.tax_id_type == '' || tax.tax_id_type == null || tax.tax_id_type == undefined) && (tax.tax_id.length == 8)){
                        this.is_tax_type = true
                        this.$emit("check_tax",this.is_tax_type)
                    }
                    if(tax.tax_id_type && (tax.tax_id.length == 8)){
                        this.is_tax_type = false
                        this.$emit("check_tax",this.is_tax_type)
                    }

                })
            },
            updateForce() {
                this.$forceUpdate();
            },
            taxTypeSelected(tax_type, index,tax) {
                this.current_tac_index = index;
                if(tax.tax_id.length < 8){
                    this.is_tax_type = true
                    this.$emit("check_tax",this.is_tax_type)
                }
                else if(tax.tax_id.length == 8){
                    this.is_tax_type = false
                    this.$emit("check_tax",this.is_tax_type)
                }
                this.$forceUpdate()
            },
            // Getting User Data
            GetUserDetails(id) {
                this.ajaxCallinprogress = true;
                this.$http
                    .post("/users/get_user_data", {
                        user_id: id
                    })
                    .then(response => {
                        if (response.data.status_id == 1) {
                            this.userBasicInfo = response.data.response;
                            let requiredData = JSON.parse(JSON.stringify(this.userBasicInfo));
                            this.editPersonalData = {
                                first_name: {
                                    value: this.userBasicInfo.first_name ? this.userBasicInfo.first_name.value :
                                        "",
                                    privacy: "contacts",
                                },
                                middle_name: {
                                    value: this.userBasicInfo.middle_name ? this.userBasicInfo.middle_name
                                        .value : "",
                                    privacy: "contacts",
                                },
                                last_name: {
                                    value: this.userBasicInfo.last_name ? this.userBasicInfo.last_name.value :
                                        "",
                                    privacy: "contacts",
                                },
                                gender: {
                                    value: this.userBasicInfo.gender ? this.userBasicInfo.gender.value : "Male",
                                    privacy: "contacts",
                                },
                                date_of_birth: {
                                    value: this.userBasicInfo.date_of_birth ? this.userBasicInfo.date_of_birth
                                        .value : "",
                                    privacy: "contacts",
                                },
                                about: {
                                    value: this.userBasicInfo.about ? this.userBasicInfo.about.value : "",
                                    privacy: "contacts",
                                },
                            };
                            if (requiredData.tax_id) {
                                Object.assign(this.editPersonalData, {
                                    tax_id: requiredData.tax_id,
                                });
                                if (this.editPersonalData.tax_id && this.editPersonalData.tax_id.length) {
                                    this.editPersonalData.tax_id.forEach(x => {
                                        let n = x.tax_id.split("");
                                        Object.assign(x, {
                                            tax1: n[0] || "",
                                            tax2: n[1] || "",
                                            tax3: n[2] || "",
                                            tax4: n[3] || "",
                                            tax5: n[4] || "",
                                            tax6: n[5] || "",
                                            tax7: n[6] || "",
                                            tax8: n[7] || "",
                                        });
                                    });
                                }
                            } else {
                                Object.assign(this.editPersonalData, {
                                    tax_id: [{
                                        tax_id_type: "",
                                        tax_id: "",
                                    }],
                                });
                            }
                            this.ajaxCallinprogress = false;
                        }
                    })
                    .catch(error => {});
            },
        },
        components: {
            QrcodeVue,
            VueTextareaAutosize,
            HalfCircleSpinner,
        },
        mounted() {
            EventBus.$on("basicInformation", () => {
                this.updatePersonalInfo();
            });
            EventBus.$on("hideuser", () => {
                this.hideEdit();
            });
        },
        created() {
            if (this.$route.params.id) {
                this.GetUserDetails(this.$route.params.id);
            } else {
                this.GetUserDetails(this.loggedInUser._id);
            }
            const dict = {
                custom: {
                    first_name: {
                        required: () => 'First Name is Required',
                        regex: () => 'Enter a Valid Name'
                    },
                    last_name: {
                        required: () => 'Last Name is Required',
                        regex: () => 'Enter a Valid Name'
                    },
                    gender: {
                        required: () => "Gender is Required",
                    },
                }
            }
            this.$validator.localize('en', dict);
        },
        destroyed() {
            EventBus.$off("basicInformation");
            EventBus.$off("hideuser");
        },
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
        }
    };
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/EditPersonalInfoView.vue